import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DepartModal from "./modules/DepartModal";
import pick from 'lodash.pick';
import { queryDepartTreeList, searchByKeywords, deleteByDepartId } from '@/api/api';
import { httpAction, deleteAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin'; // 表头

var columns = [{
  title: '机构名称',
  dataIndex: 'departName'
}, {
  title: '机构类型',
  align: 'center',
  dataIndex: 'orgType'
}, {
  title: '机构编码',
  dataIndex: 'orgCode'
}, {
  title: '手机号',
  dataIndex: 'mobile'
}, {
  title: '传真',
  dataIndex: 'fax'
}, {
  title: '地址',
  dataIndex: 'address'
}, {
  title: '排序',
  align: 'center',
  dataIndex: 'departOrder'
}, {
  title: '操作',
  align: 'center',
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  }
}];
export default {
  name: 'DepartList',
  mixins: [JeecgListMixin],
  components: {
    DepartModal: DepartModal
  },
  data: function data() {
    return {
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: '',
      currFlowName: '',
      disable: true,
      treeData: [],
      visible: false,
      departTree: [],
      rightClickSelectedKey: '',
      hiding: true,
      model: {},
      dropTrigger: '',
      depart: {},
      columns: columns,
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      autoIncr: 1,
      currSelected: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      graphDatasource: {
        nodes: [],
        edges: []
      },
      validatorRules: {
        departName: {
          rules: [{
            required: true,
            message: '请输入机构/部门名称!'
          }]
        },
        orgCode: {
          rules: [{
            required: true,
            message: '请输入机构编码!'
          }]
        },
        mobile: {
          rules: [{
            validator: this.validateMobile
          }]
        }
      },
      url: {
        delete: '/sysdepart/sysDepart/delete',
        edit: '/sysdepart/sysDepart/edit',
        deleteBatch: '/sysdepart/sysDepart/deleteBatch',
        exportXlsUrl: "sysdepart/sysDepart/exportXls",
        importExcelUrl: "sysdepart/sysDepart/importExcel"
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    loadData: function loadData() {
      this.refresh();
    },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.treeData = [];
      that.departTree = [];
      queryDepartTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.treeData.push(temp);
            that.departTree.push(temp);
            that.setThisExpandedKeys(temp);
            console.log(temp.id);
          }

          _this.loading = false;
        }
      });
    },
    setThisExpandedKeys: function setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);

        for (var a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a]);
        }
      }
    },
    refresh: function refresh() {
      this.loading = true;
      this.loadTree();
    },
    // 右键操作方法
    rightHandle: function rightHandle(node) {
      this.dropTrigger = 'contextmenu';
      console.log(node.node.eventKey);
      this.rightClickSelectedKey = node.node.eventKey;
    },
    onExpand: function onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    backFlowList: function backFlowList() {
      this.$router.back(-1);
    },
    // 右键点击下拉框改变事件
    dropStatus: function dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = '';
      }
    },
    // 右键店家下拉关闭下拉框
    closeDrop: function closeDrop() {
      this.dropTrigger = '';
    },
    addRootNode: function addRootNode() {
      this.$refs.nodeModal.add(this.currFlowId, '');
    },
    batchDel: function batchDel() {
      console.log(this.checkedKeys);

      if (this.checkedKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
      } else {
        var ids = '';

        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '确定要删除所选中的 ' + this.checkedKeys.length + ' 条数据?',
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadTree();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    onSearch: function onSearch(value) {
      var that = this;

      if (value) {
        searchByKeywords({
          keyWord: value
        }).then(function (res) {
          if (res.success) {
            that.departTree = [];

            for (var i = 0; i < res.result.length; i++) {
              var temp = res.result[i];
              that.departTree.push(temp);
            }
          } else {
            that.$notification.warning({
              message: res.message
            });
          }
        });
      } else {
        that.loadTree();
      }
    },
    nodeModalOk: function nodeModalOk() {
      this.loadTree();
    },
    nodeModalClose: function nodeModalClose() {},
    hide: function hide() {
      console.log(111);
      this.visible = false;
    },
    onCheck: function onCheck(checkedKeys, info) {
      console.log('onCheck', checkedKeys, info);
      this.hiding = false;
      this.checkedKeys = checkedKeys.checked;
    },
    onSelect: function onSelect(selectedKeys, e) {
      console.log('selected', selectedKeys, e);
      this.hiding = false;
      var record = e.node.dataRef;
      console.log('onSelect-record', record);
      this.currSelected = Object.assign({}, record);
      this.model = this.currSelected;
      this.selectedKeys = [record.key];
      this.model.parentId = record.parentId;
      this.setValuesToForm(record);
    },
    // 触发onSelect事件时,为部门树右侧的form表单赋值
    setValuesToForm: function setValuesToForm(record) {
      this.form.getFieldDecorator('fax', {
        initialValue: ''
      });
      this.form.setFieldsValue(pick(record, 'departName', 'orgCode', 'departOrder', 'mobile', 'fax', 'address', 'memo'));
    },
    getCurrSelectedTitle: function getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title;
    },
    onClearSelected: function onClearSelected() {
      this.hiding = true;
      this.checkedKeys = {};
      this.currSelected = {};
      this.form.resetFields();
      this.selectedKeys = [];
    },
    handleNodeTypeChange: function handleNodeTypeChange(val) {
      this.currSelected.nodeType = val;
    },
    notifyTriggerTypeChange: function notifyTriggerTypeChange(value) {
      this.currSelected.notifyTriggerType = value;
    },
    receiptTriggerTypeChange: function receiptTriggerTypeChange(value) {
      this.currSelected.receiptTriggerType = value;
    },
    submitCurrForm: function submitCurrForm() {
      var _this2 = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          if (!_this2.currSelected.id) {
            _this2.$message.warning('请点击选择要修改部门!');

            return;
          }

          var formData = Object.assign(_this2.currSelected, values);
          console.log('Received values of form: ', formData);
          httpAction(_this2.url.edit, formData, 'put').then(function (res) {
            if (res.success) {
              _this2.$notification.success({
                message: '保存成功!'
              });

              _this2.loadTree();
            } else {
              _this2.$message.error(res.message);
            }
          });
        }
      });
    },
    emptyCurrForm: function emptyCurrForm() {
      this.form.resetFields();
    },
    nodeSettingFormSubmit: function nodeSettingFormSubmit() {
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    openSelect: function openSelect() {
      this.$refs.sysDirectiveModal.show();
    },
    handleAdd: function handleAdd(num) {
      if (num == 1) {
        this.$refs.departModal.add();
        this.$refs.departModal.title = '新增';
      } else if (num == 2) {
        var key = this.currSelected.key;

        if (!key) {
          this.$message.warning('请先选中一条记录!');
          return false;
        }

        this.$refs.departModal.add(this.selectedKeys);
        this.$refs.departModal.title = '新增';
      } else {
        this.$refs.departModal.add(this.rightClickSelectedKey);
        this.$refs.departModal.title = '新增';
      }
    },
    handleDelete: function handleDelete() {
      var _this3 = this;

      deleteByDepartId({
        id: this.rightClickSelectedKey
      }).then(function (resp) {
        if (resp.success) {
          _this3.$notification.success({
            message: '删除成功!'
          });

          _this3.loadTree();
        } else {
          _this3.$notification.warning({
            message: '删除失败!'
          });
        }
      });
    },
    selectDirectiveOk: function selectDirectiveOk(record) {
      console.log('选中指令数据', record);
      this.nodeSettingForm.setFieldsValue({
        directiveCode: record.directiveCode
      });
      this.currSelected.sysCode = record.sysCode;
    },
    getFlowGraphData: function getFlowGraphData(node) {
      this.graphDatasource.nodes.push({
        id: node.id,
        text: node.flowNodeName
      });

      if (node.children.length > 0) {
        for (var a = 0; a < node.children.length; a++) {
          var temp = node.children[a];
          this.graphDatasource.edges.push({
            source: node.id,
            target: temp.id
          });
          this.getFlowGraphData(temp);
        }
      }
    }
  },
  created: function created() {
    this.currFlowId = this.$route.params.id;
    this.currFlowName = this.$route.params.name; // this.loadTree()
  }
};